/**
 * MT Product Stick - 产品粘性栏功能
 * 使用 Shopify 原生表单，只处理显示/隐藏和展开/收起功能
 */

(function() {
  'use strict';

  /**
   * 初始化产品粘性栏的显示/隐藏逻辑
   * @param {Object} config - 配置对象
   */
  function initProductStickVisibility(config) {
    const { disappearClass } = config;

    // Sticky bar 元素
    const productStick = document.querySelector('.mt-product-stick');

    // 如果没有找到组件，直接返回
    if (!productStick) return;

    // 默认先隐藏，避免首屏闪烁
    productStick.classList.add('is-hidden');

    // 单个"分界线"元素：在它上面不显示，从它开始往下才显示
    let dividerEl = null;
    if (disappearClass && disappearClass.trim()) {
      let sel = disappearClass.trim();
      if (!sel.startsWith('.') && !sel.startsWith('#') && !sel.startsWith('[')) {
        sel = '.' + sel;
      }
      dividerEl = document.querySelector(sel);
    }

    let reachedDivider = false;
    let footerVisible = false;

    function updateProductStickVisibility() {
      // 只要还没到分界线，或者 footer 已经出现，就隐藏
      if (!reachedDivider || footerVisible) {
        productStick.classList.add('is-hidden');
      } else {
        productStick.classList.remove('is-hidden');
      }
    }

    function checkDividerVisibility() {
      if (!dividerEl || !dividerEl.getBoundingClientRect) {
        // 如果没配置分界线，那就默认认为"已经过了分界线"，由 footer 控制显示/隐藏
        const wasReached = reachedDivider;
        reachedDivider = true;
        // 只有当状态改变时才更新
        if (wasReached !== reachedDivider) {
          updateProductStickVisibility();
        }
        return;
      }

      const rect = dividerEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 当分界线进入视口（顶部进入视口区域）或者已经滚动到分界线以下，都视为"到达分界线"
      const wasReached = reachedDivider;
      reachedDivider = rect.top <= windowHeight;
      // 只有当状态改变时才更新
      if (wasReached !== reachedDivider) {
        updateProductStickVisibility();
      }
    }

    // 查找 footer 元素（尝试多种选择器，优先使用实际可见的 mt-footer）
    let footerEl = null;
    
    // 1. 先尝试你主题里真实的 footer：<footer class="mt-footer" ...>
    footerEl = document.querySelector('footer.mt-footer') || document.querySelector('.mt-footer');
    
    // 2. 如果还没找到，再退回到通用 footer 选择器
    if (!footerEl) {
      footerEl = document.querySelector('footer');
    }
    if (!footerEl) {
      footerEl = document.querySelector('.footer, #footer, [class*="footer"], [id*="footer"]');
    }
    
    // 检查footer是否可见的函数
    function checkFooterVisibility() {
      if (!footerEl) {
        // 如果没有footer，footer永远不可见
        const wasVisible = footerVisible;
        footerVisible = false;
        if (wasVisible !== footerVisible) {
          updateProductStickVisibility();
        }
        return;
      }
      
      const rect = footerEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // 如果这个 footer 没有尺寸（可能是一个不可见的占位元素），当作不存在处理
      if (rect.width === 0 && rect.height === 0) {
        const wasVisible = footerVisible;
        footerVisible = false;
        if (wasVisible !== footerVisible) {
          updateProductStickVisibility();
        }
        return;
      }
      
      // 计算 footer 顶部和底部位置
      const footerTop = rect.top;
      const footerBottom = rect.bottom;
      
      // 当 footer 进入视口（任意一部分可见）时，就认为需要隐藏粘性组件
      // 条件：footer 顶部 < 视口底部，且 footer 底部 > 视口顶部
      const wasVisible = footerVisible;
      footerVisible = footerTop < windowHeight && footerBottom > 0;

      
      // 只有当状态改变时才更新 DOM 状态，避免不必要的操作
      if (wasVisible !== footerVisible) {
        updateProductStickVisibility();
      }
    }
    
    // 完全依赖手动检测，因为它可以精确处理缓冲区域
    // 使用节流来优化性能
    let scrollTimeout;
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    function handleScroll() {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // 统一处理：同时检查分界线和footer
      // 每次滚动都检查，确保状态同步
      // 取消之前的动画帧请求
      if (scrollTimeout) {
        cancelAnimationFrame(scrollTimeout);
      }
      
      // 使用requestAnimationFrame确保在浏览器重绘前执行
      scrollTimeout = requestAnimationFrame(() => {
        // 先检查分界线
        checkDividerVisibility();
        // 再检查footer
        checkFooterVisibility();
        // 确保最终状态正确（即使两个函数的状态都没有改变，也要确保DOM状态正确）
        updateProductStickVisibility();
        lastScrollTop = currentScrollTop;
      });
    }
    
    // 统一的滚动监听器，避免多个监听器冲突
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', function() {
      // 取消之前的动画帧请求
      if (scrollTimeout) {
        cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = requestAnimationFrame(() => {
        checkDividerVisibility();
        checkFooterVisibility();
        // 确保最终状态正确
        updateProductStickVisibility();
      });
    });
    
    // 初始检查一次
    checkDividerVisibility();
    checkFooterVisibility();
  }

  // 导出到全局
  window.MTProductStick = {
    initVisibility: initProductStickVisibility
  };
})();
